document.addEventListener("DOMContentLoaded", function () {
    const form = document.getElementById('cs-form');
    const submitButton = form.querySelector('button[type="submit"]');
    const requiredFields = form.querySelectorAll('input[required], textarea[required]');
    const customAlert = document.getElementById('custom-alert');
    const customAlertMessage = document.getElementById('custom-alert-message');
    const customAlertClose = document.getElementById('custom-alert-close');

    // Función para mostrar la alerta personalizada
    function showCustomAlert(message, type) {
        customAlertMessage.textContent = message;
        customAlert.classList.add('custom-alert-' + type);
        customAlert.style.display = 'block';
        setTimeout(() => {
            customAlert.style.display = 'none';
            customAlert.classList.remove('custom-alert-' + type);
        }, 5000);
    }

    // Función para cerrar la alerta personalizada
    customAlertClose.addEventListener('click', function () {
        customAlert.style.display = 'none';
    });

    // Función para verificar si todos los campos obligatorios están completos
    function checkRequiredFields() {
        let allFieldsFilled = true;
        requiredFields.forEach(field => {
            const errorElement = field.nextElementSibling;
            if (!field.value.trim()) {
                allFieldsFilled = false;
                if (errorElement && errorElement.classList.contains('error-message')) {
                    errorElement.classList.add('visible');
                } else {
                    const errorMessage = document.createElement('span');
                    errorMessage.classList.add('error-message', 'visible');
                    errorMessage.textContent = 'Este campo es obligatorio';
                    field.parentNode.insertBefore(errorMessage, field.nextSibling);
                }
            } else {
                if (errorElement && errorElement.classList.contains('error-message')) {
                    errorElement.classList.remove('visible');
                }
            }
        });
        submitButton.disabled = !allFieldsFilled;
    }

    // Verificar los campos obligatorios al cargar la página
    checkRequiredFields();

    // Agregar eventos de entrada a los campos obligatorios para verificar en tiempo real
    requiredFields.forEach(field => {
        field.addEventListener('input', checkRequiredFields);
    });

    // Manejar el envío del formulario
    form.addEventListener('submit', function (event) {
        event.preventDefault(); // Evitar el envío del formulario por defecto

        // Crear un objeto FormData con los datos del formulario
        const formData = new FormData(form);

        // Enviar los datos del formulario usando fetch
        fetch(form.action, {
            method: 'POST',
            body: formData,
            headers: {
                'Accept': 'application/json'
            }
        }).then(response => {
            if (response.ok) {
                // Mostrar alerta de éxito
                showCustomAlert('Mensaje enviado con éxito. Redirigiendo...', 'success');
                // Redirigir a la página de confirmación después de un breve retraso
                setTimeout(() => {
                    window.location.href = '/contact/confirmation/';
                }, 2000);
            } else {
                // Mostrar alerta de error
                showCustomAlert('Hubo un problema al enviar el formulario. Por favor, inténtalo de nuevo.', 'error');
            }
        }).catch(error => {
            console.error('Error:', error);
            // Mostrar alerta de error
            showCustomAlert('Hubo un problema al enviar el formulario. Por favor, inténtalo de nuevo.', 'error');
        });
    });
});
